import React, { useState, useEffect } from "react";
import {
  Paper,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Collapse,
  IconButton,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Switch,
  FormControlLabel,
  Button,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { GetTempBatchesForTable } from "../../services/BatchService";
import { formatDateTime, formatIncubatorTime } from "../../common-utilities/date-utility";
import CommonLoader from "../../vlp/components/common/CommonLoader";
import NewTempBatchManager from "./NewTempBatchManager";

const NewBatchManagerTable = () => {
  const [location, setLocation] = useState("");
  const [batch, setBatch] = useState("");
  const [batchs, setBatchs] = useState([]);
  const [uniqueBatchs, setUniqueBatchs] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [searchBatchs, setSearchBatchs] = useState([]);
  const [switchChecked, setSwitchChecked] = useState(true);
  const [shouldRefresh, setShouldRefresh] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openRows, setOpenRows] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  useEffect(() => {
    async function GetData() {
      await LoadData();
    }
    GetData();
  }, [switchChecked, shouldRefresh]);

  const LoadData = async () => {
    setShowLoader(true);

    try {
      let batchData = await GetTempBatchesForTable(switchChecked);
      if (batchData) {
        const uniqueBatches = batchData.result.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.batchId === value.batchId)
        );
        setBatchs(batchData.result);
        setSearchBatchs(uniqueBatches);
        setUniqueBatchs(uniqueBatches);
      }
    } catch (err) {
      NotificationManager.error(
        "Unable to get the data. Error " + err,
        "Error"
      );
    }
    setShowLoader(false);
  };

  const handleLocationChange = (e) => {
    const selectedLocation = e.target.value.trim();
    setLocation(selectedLocation);

    filterData(selectedLocation, batch);
  };

  const handleBatchChange = (e) => {
    const selectedBatch = e.target.value.trim();
    setBatch(selectedBatch);

    filterData(location, selectedBatch);
  };

  const filterData = (selectedLocation, selectedBatch) => {
    let filtered = Array.isArray(searchBatchs) ? [...searchBatchs] : [];

    filtered = filtered.filter(
      (batch) =>
        (!selectedLocation ||
          batch.location?.trim().toLowerCase() ===
          selectedLocation.toLowerCase()) &&
        (!selectedBatch ||
          batch.type?.trim().toLowerCase() === selectedBatch.toLowerCase())
    );

    setUniqueBatchs(filtered);
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };
  const handleSwitchChange = (event) => {
    setSwitchChecked(event.target.checked);
  };

  const handleRefresh = () => {
    setShouldRefresh(!shouldRefresh);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const sortedData = [...uniqueBatchs].sort((a, b) => {
      if (a[property] < b[property]) return isAsc ? -1 : 1;
      if (a[property] > b[property]) return isAsc ? 1 : -1;
      return 0;
    });
    setUniqueBatchs(sortedData);
  };

  const handleEditClick = (batchId) => {
    console.log("Edit batch with ID:", batchId);
    const batchToEdit = batchs.filter((batch) => batch.batchId === batchId);
    if (batchToEdit) {
      setSelectedBatch(batchToEdit);
      setOpenPopup(true);
    }
  };

  const handleViewClick = (batchId) => {
    setOpenRows((prev) => ({
      ...prev,
      [batchId]: !prev[batchId], // Toggle the current batchId
    }));
  };

  const handleDeleteClick = (batchId) => {
    console.log("Delete batch with ID:", batchId);
  };

  const locations = [
    "Madison 1",
    "Madison 2",
    "Madison 3",
  ];

  const renderActions = (orderId) => (
    <div style={{ minWidth: "120px" }}>
      <IconButton
        aria-label="edit"
        style={{ color: "orange" }}
        onClick={() => handleEditClick(orderId)}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        aria-label="view"
        style={{ color: "green" }}
        onClick={() => handleViewClick(orderId)}
      >
        <VisibilityIcon />
      </IconButton>
      <IconButton
        aria-label="delete"
        style={{ color: "red" }}
        onClick={() => handleDeleteClick(orderId)}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );

  return (
    <>
      <div className="vlp-component-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="title">Batch Manager</span>
        </div>
        <hr />

        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <FormControl sx={{ minWidth: 300 }} variant="outlined" size="small">
            <InputLabel id="analysis-type-label">Analysis Type</InputLabel>
            <Select
              labelId="analysis-type-label"
              value={batch}
              onChange={handleBatchChange}
              label="Analysis Type"
              fullWidth
            >
              <MenuItem value="">
                <em>All analysis type</em>
              </MenuItem>
              <MenuItem value="HPC">HPC (Pool)</MenuItem>
              <MenuItem value="TCDW">TC (DW)</MenuItem>
              <MenuItem value="TCPOOL">TC (Pool)</MenuItem>
              <MenuItem value="Ecoli">E.coli</MenuItem>
              <MenuItem value="HPCDW">HPC (DW)</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 300 }} variant="outlined" size="small">
            <InputLabel id="select-location-label">Select location</InputLabel>
            <Select
              labelId="select-location-label"
              value={location}
              onChange={handleLocationChange}
              label="Select location"
              fullWidth
            >
              <MenuItem value="">
                <em>All locations</em>
              </MenuItem>
              {locations
                .sort((a, b) => a.localeCompare(b))
                .map((location) => (
                  <MenuItem key={location} value={location}>
                    {location}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControlLabel
            control={
              <Switch
                checked={switchChecked}
                onChange={handleSwitchChange}
                name="toggleSwitch"
              />
            }
            label="Show Reviewed"
          />

          <Button variant="outlined" color="primary" onClick={handleRefresh}>
            Refresh
          </Button>
        </div>

        <Paper>
          <TableContainer
            sx={{ maxHeight: 500, overflowY: "auto", width: "99%" }}
          >
            <Table sx={{ minWidth: 700 }} aria-label="batch manager table" size="small" stickyHeader>
              <TableHead
                sx={{
                  backgroundColor: (theme) => theme.palette.primary.main,
                  color: "white",
                }}
              >
                <TableRow>
                  {[
                    "batchId",
                    "type",
                    "location",
                    "inTime",
                    "inUser",
                    "outTime",
                    "outUser",
                  ].map((column) => (
                    <TableCell key={column}>
                      <TableSortLabel
                        active={orderBy === column}
                        direction={orderBy === column ? order : "asc"}
                        onClick={() => handleRequestSort(column)}
                      >
                        {column.charAt(0).toUpperCase() + column.slice(1)}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell>Incubator Time</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uniqueBatchs
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((batch, index) => (
                    <React.Fragment key={batch.batchId}>
                      <TableRow
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "rgba(0, 0, 0, 0.04)" : "white",
                        }}
                      >
                        <TableCell>{batch.batchId}</TableCell>
                        <TableCell>{batch.type}</TableCell>
                        <TableCell>{batch.location}</TableCell>
                        <TableCell>{formatDateTime(batch.inTime)}</TableCell>
                        <TableCell>{batch.inUser}</TableCell>
                        <TableCell>{formatDateTime(batch.outTime)}</TableCell>
                        <TableCell>{batch.outUser}</TableCell>
                        <TableCell>{formatIncubatorTime(batch.inTime, batch.outTime)}</TableCell>
                        <TableCell>{renderActions(batch.batchId)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={9}
                        >
                          <Collapse
                            in={!!openRows[batch.batchId]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box margin={1}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Sample ID</TableCell>
                                    <TableCell>Reviewed</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {batchs
                                    .filter(
                                      (sample) =>
                                        sample.batchId === batch.batchId
                                    )
                                    .map((sample) => (
                                      <TableRow key={sample.sampleLabId}>
                                        <TableCell>{sample.id}</TableCell>
                                        <TableCell>
                                          {sample.sampleLabId}
                                        </TableCell>
                                        <TableCell>
                                          {sample.reviewed ? "Yes" : "No"}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={uniqueBatchs.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) =>
              setRowsPerPage(parseInt(event.target.value, 10))
            }
          />
        </Paper>
      </div>

      <CommonLoader loading={showLoader} />

      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <NewTempBatchManager
            location={location}
            batch={batch}
            switchChecked={switchChecked}
            shouldRefresh={shouldRefresh}
            selectedBatches={selectedBatch}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewBatchManagerTable;
